module.exports = __webpack_public_path__ + "images/feature/20160401_01-8b3c8e58f46678fe881df343c9ae3920.png";